import { Box } from "@mantine/core";
import { type PossibleTabs } from "../Home";
import CallbackList from "../Features/Callback/CallbackList";
import AppointmentList from "../Features/Appointment/AppointmentList";
import ActiveCasesList from "../Features/ActiveCases/ActiveCasesList";
import RecentLeadsList from "../Features/RecentLeads/RecentLeadsList";
import OmnichannelList from "../Features/Omnichannel/OmnichannelList";
import OpenLeadsList from "../Features/OpenLeads/OpenLeadsList";

interface HomeListsProps {
  activeTab: PossibleTabs;
}

export default function HomeLists({ activeTab }: HomeListsProps) {
  let content;

  switch (activeTab) {
    case "Appointment":
      content = <AppointmentList />;
      break;
    case "Callback":
      content = <CallbackList />;
      break;
    case "ActiveCases":
      content = <ActiveCasesList />;
      break;
    case "RecentLeads":
      content = <RecentLeadsList />;
      break;
    case "Omnichannel":
      content = <OmnichannelList />;
      break;
    case "OpenLeads":
      content = <OpenLeadsList />;
      break;
    default:
      content = null;
  }

  return <Box>{content}</Box>;
}
